export default __webpack_public_path__ + "static/media/qr_chplay_yokara.92a6e181.svg";